export const APP_STORAGE = Object.freeze({
  APP_LANGUAGE: "APP_LANGUAGE", APP_PREFERENCES: "APP_PREFERENCES", APP_SESSION: "APP_SESSION",
  APP_THEME: "APP_THEME", AUTH_VERIFY_EMAIL: "AUTH_VERIFY_EMAIL", TOKEN_USER_AUTH: "TOKEN_USER_AUTH",
});
